class MobileMenu extends HTMLElement {
  constructor() {
    super();

    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.mobileMenuText = this.querySelector("[data-mobile-menu-text]");
    this.mobileSearchInput = this.querySelector("[data-mobile-search-input]");
    this.mobileMenuLinks = this.querySelector("[data-mobile-menu-links]");
    this.mobileSearch = this.querySelector("[data-mobile-search]");
    this.mobileUtilities = this.querySelector("[data-mobile-utilities]");
    this.mobileLocalization = this.querySelector("[data-mobile-localization]");
    this.mobileLocalizationToggle =
      this.mobileUtilities.querySelector(".localization");
    this.mobileAccount = this.mobileUtilities.querySelector(
      "[data-mobile-account]",
    );
    this.mobileLocalizationSummary = this.mobileUtilities.querySelector(
      ".localization summary",
    );
  }

  connectedCallback() {
    this.summary.addEventListener("click", (e) => {
      if (this.dataset.searchOpen == "true") {
        e.preventDefault();
        this.searchClose();
        return;
      } else if (this.dataset.localesOpen == "true") {
        e.preventDefault();
        this.localizationClose(true);
        return;
      } else {
        this._toggle();
      }
    });

    this.addEventListener("mobile-submenu:close", () => {
      window.trapFocus(this.details);
    });

    this.mobileSearchInput.addEventListener("focus", () => {
      this.searchOpen();
    });

    this.mobileLocalizationSummary.addEventListener("click", () => {
      if (this.mobileLocalizationToggle.open) {
        this.localizationClose();
      } else {
        this.localizationOpen();
      }
    });

    this.closeEsc = (e) => {
      if (e.key === "Escape" && this.classList.contains("open")) {
        if (this.dataset.searchOpen == "true") {
          e.preventDefault();
          this.searchClose();
          return;
        }

        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    this.toggleDrawer = () => {
      if (!this._isMobile && this.details.open) {
        this._forceClose();
      }
    };

    window.addEventListener("resize", this.toggleDrawer);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    window.removeEventListener("resize", this.toggleDrawer);
  }

  searchOpen() {
    this.mobileMenuLinks.style.display = "none";
    this.mobileUtilities.style.display = "none";
    this.dataset.searchOpen = true;
  }

  searchClose() {
    this.mobileMenuLinks.style.display = "block";
    this.mobileUtilities.style.display = "flex";
    this.dataset.searchOpen = false;
  }

  localizationOpen() {
    this.mobileMenuLinks.style.display = "none";
    this.mobileSearch.style.display = "none";
    this.mobileAccount.style.display = "none";
    this.dataset.localesOpen = true;
  }

  localizationClose(forceClose = false) {
    this.mobileMenuLinks.style.display = "block";
    this.mobileSearch.style.display = "block";
    this.mobileAccount.style.display = "block";

    if (forceClose) {
      this.mobileLocalizationToggle.classList.remove("open");
      this.mobileLocalizationToggle.open = false;
    }

    this.dataset.localesOpen = false;
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _open() {
    this.mobileMenuText.textContent = this.dataset.isOpen;
    window.requestAnimationFrame(() => {
      this.classList.add("open");
      this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
      window.lockScroll(this);
    });
    window.trapFocus(this.details);
  }

  _close() {
    this.classList.remove("open");

    this.mobileMenuText.textContent = this.dataset.isClose;
    this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    this.localizationClose(true);

    if (this.classList.contains("open")) return;

    setTimeout(() => {
      this.details.open = false;
      window.removeTrapFocus(this.summary);
      window.unlockScroll(this);
      this.dispatchEvent(
        new CustomEvent("mobile-menu:closed", { bubbles: true }),
      );
    }, 250);
  }

  _forceClose() {
    this._close();
  }
}

if (!customElements.get("mobile-menu")) {
  customElements.define("mobile-menu", MobileMenu);
}
